import { ChangeLogEntryData } from "./ChangeLogEntryData";
import { ToolVersionData } from "./ToolVersionData";
import { LicensingType } from "@/helpers/EnumHelpers";
import { ProductToolData } from "./ProductToolData";

export class ProductVersionData extends ToolVersionData {
  public licensingId: number;
  public hidden: boolean;
  public msrp: number;
  public supportedLicensingTypes: LicensingType;
  public productId: string;
  public tools: ProductToolData[];
  public latest: boolean;
  public multiInstallerUri: string;
  public singleInstallerUri: string;
  constructor(
    pName: string,
    pMinSupportedVersion: string,
    pMaxSupportedVersion: string,
    pPublshedUTC: Date,
    pChangeLog: ChangeLogEntryData[],
    pId: string,
    pOwnerId: string,
    pOriginalChangeLog: ChangeLogEntryData[],
    pSupportedLicensingTypes: LicensingType,
    pLicensingId: number,
    pHidden: boolean,
    pMSRP: number,
    pTools: ProductToolData[],
    pLatest: boolean,
    pSingleUserInstallerUri: string,
    pMultiUserInstallerUri: string
  ) {
    super(
      pName,
      pMinSupportedVersion,
      pMaxSupportedVersion,
      pPublshedUTC,
      pChangeLog,
      pId,
      pOwnerId,
      pOriginalChangeLog
    );
    this.supportedLicensingTypes = pSupportedLicensingTypes;
    this.licensingId = pLicensingId;
    this.hidden = pHidden;
    this.msrp = pMSRP;
    this.productId = pOwnerId;
    this.tools = pTools;
    this.latest = pLatest;
    this.singleInstallerUri = pSingleUserInstallerUri;
    this.multiInstallerUri = pMultiUserInstallerUri;
  }
}
